import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { config } from '../config';
import axios from 'axios';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import { FaCheck, FaCrown, FaRocket, FaStar, FaMedal, FaChalkboardTeacher, FaCertificate, FaClock } from 'react-icons/fa';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as AiIcons from 'react-icons/ai';
import * as BsIcons from 'react-icons/bs';

const apiUrl = config.apiUrl;

const Memberships = () => {
  const [memberships, setMemberships] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const membershipIcons = [<FaMedal className="text-amber-500" />, <FaCrown className="text-yellow-500" />, <FaRocket className="text-purple-500" />];
  const membershipColors = ["from-blue-500 to-blue-600", "from-amber-500 to-amber-600", "from-purple-500 to-purple-600"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/memberships`);
        setMemberships(response.data || []);

        console.log(response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load memberships. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

   const getIconComponent = (iconName) => {
        const libraries = { ...FaIcons, ...MdIcons, ...AiIcons, ...BsIcons };
        const Icon = libraries[iconName];
        return Icon ? <Icon /> : <span>✅</span>;
      };


  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-gradient-to-b from-gray-50 to-white"
      >
        {/* Hero Section */}
        <div className="relative py-20 bg-gradient-to-r from-green-600 to-blue-600 text-white overflow-hidden pt-32">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-purple-300 rounded-full mix-blend-screen filter blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-300 rounded-full mix-blend-screen filter blur-3xl"></div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-3xl mx-auto"
            >
              <h1 className="text-4xl md:text-5xl font-bold mb-6">আপনার সাফল্যের জন্য সেরা মেম্বারশিপ</h1>
              <p className="text-xl md:text-2xl mb-8">
                আমাদের এক্সক্লুসিভ মেম্বারশিপ প্ল্যান বেছে নিন এবং জ্ঞান অর্জনের সুযোগকে আরো বাড়িয়ে নিন
              </p>
            </motion.div>
          </div>
        </div>

        {/* Membership Plans */}
        <div className="container mx-auto px-4 py-16">
          {error && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-red-50 border-l-4 border-red-500 p-4 mb-8 rounded-lg"
            >
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-red-700">{error}</p>
                </div>
              </div>
            </motion.div>
          )}

          {memberships.length > 0 ? (
            <motion.div
              variants={container}
              initial="hidden"
              animate="show"
              className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto"
            >
              {memberships.map((membership, index) => (
                <motion.div
                  key={membership.id}
                  variants={item}
                  whileHover={{ y: -10 }}
                  className={`relative rounded-xl shadow-xl overflow-hidden transition-all duration-300 ${index === 1 ? 'transform scale-105 z-10' : ''}`}
                >
                  {/* Recommended badge */}
                  {index === 1 && (
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-2 bg-yellow-400 text-white font-semibold px-4 py-1 rounded-full shadow-md">
                      MOST POPULAR
                    </div>
                  )}

                  {/* Card Header */}
                  <div className={`bg-gradient-to-r ${membershipColors[index]} p-6 text-white`}>
                    <div className="flex items-center justify-between">
                      <div className="text-3xl">
                        {membershipIcons[index]}
                      </div>
                      <div className="text-right">
                        <span className="text-sm opacity-80">STARTING AT</span>
                        <div className="text-3xl font-bold">{membership.discount_price} ৳</div>
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold mt-4">{membership.membership_type}</h3>
                  </div>

                   {/* Dynamic Benefits */}
                  {membership.benefits && membership.benefits.length > 0 && (
                    <div className="mt-6 mb-4 mx-4">
                      {membership.benefits.map((benefit, i) => (
                        <div key={i} className="flex items-center mb-2">
                          <span className="mr-2">{getIconComponent(benefit.icon)}</span>
                          <span className="text-gray-700">{benefit.benefit_name}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Card Body */}
                  <div className="bg-white p-6">
                    <div className="mb-6">
                      <div className="text-gray-500 line-through mb-1">
                        Regular Price: {membership.selling_price} ৳
                      </div>
                      <div className="text-green-600 font-bold">
                        You save: {membership.selling_price - membership.discount_price} ৳!
                      </div>
                    </div>

                    {/* <ul className="space-y-3 mb-8">
                      {membership.membership_description &&
                      (membership.membership_description.split('<br>').map((feature, i) => (
                        <li key={i} className="flex items-start">
                          <FaCheck className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                          <span className="text-gray-700"> <div dangerouslySetInnerHTML={{ __html: feature }} /></span>
                        </li>
                      )))
                      }
                    </ul> */}

                    <motion.button
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      onClick={() => navigate(`/purchase/membership/${membership.id}`)}
                      className={`w-full py-3 px-6 rounded-lg font-bold text-white ${index === 1 ? 'bg-gradient-to-r from-amber-500 to-amber-600 shadow-lg' : 'bg-gradient-to-r from-blue-500 to-blue-600'}`}
                    >
                      Get Started
                    </motion.button>
                  </div>

                  {/* Hover effect overlay */}
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-green-400 rounded-xl pointer-events-none transition-all duration-300 m-1"></div>
                </motion.div>
              ))}
            </motion.div>
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-16 bg-white rounded-xl shadow-sm"
            >
              <div className="inline-block p-4 bg-green-100 rounded-full mb-4">
                <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">No Plans Available</h3>
              <p className="text-gray-600 max-w-md mx-auto">
                We're currently updating our membership plans. Please check back soon!
              </p>
            </motion.div>
          )}

          {/* Testimonials */}
          {/* <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="mt-16 bg-indigo-50 rounded-xl p-8"
          >
            <h2 className="text-2xl font-bold text-center mb-8">What Our Members Say</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { 
                  quote: "This membership transformed my learning experience. Worth every penny!", 
                  name: "Rahim Khan", 
                  role: "Web Developer",
                  rating: 5
                },
                { 
                  quote: "The exclusive content helped me advance my career significantly.", 
                  name: "Fatima Ahmed", 
                  role: "Graphic Designer",
                  rating: 5
                },
                { 
                  quote: "Best investment I've made in my professional development.", 
                  name: "Arif Hasan", 
                  role: "Data Scientist",
                  rating: 5
                }
              ].map((testimonial, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-white p-6 rounded-lg shadow-md"
                >
                  <div className="flex items-center mb-4">
                    <div className="flex-shrink-0 bg-indigo-100 p-2 rounded-full">
                      <svg className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <p className="text-sm font-medium text-gray-900">{testimonial.name}</p>
                      <p className="text-sm text-gray-500">{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="flex mb-3">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={`text-sm ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`} />
                    ))}
                  </div>
                  <p className="text-gray-600 italic">"{testimonial.quote}"</p>
                </motion.div>
              ))}
            </div>
          </motion.div> */}

          {/* FAQ Section */}
          {/* <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="mt-16 bg-white rounded-xl shadow-md p-8"
          >
            <h2 className="text-2xl font-bold text-center mb-8">Frequently Asked Questions</h2>
            <div className="space-y-4 max-w-3xl mx-auto">
              {[
                {
                  question: "How do I cancel my membership?",
                  answer: "You can cancel anytime from your account settings. No cancellation fees."
                },
                {
                  question: "Can I upgrade or downgrade my plan?",
                  answer: "Yes, you can change your plan anytime. The changes will apply in your next billing cycle."
                },
                {
                  question: "Is there a free trial available?",
                  answer: "We occasionally offer free trials. Check our promotions page for current offers."
                }
              ].map((faq, index) => (
                <div key={index} className="border-b border-gray-200 pb-4">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">{faq.question}</h3>
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              ))}
            </div>
          </motion.div> */}
        </div>
      </motion.main>
      
      <Footer />
    </>
  );
};

export default Memberships;